import React, { useEffect } from 'react';

import { useQueryParams } from 'utils/hooks/useQueryParams';
import { useTranslations } from 'utils/hooks/useTranslations';

import { BFS_DOI_TOKEN_QUERY_KEY, BfsDoiResultStatus } from '../BfsDoubleOptIn.model';
import BfsDoiResultPage from '../components/BfsDoiResultPage';
import { useConfirmBfsDoi } from '../hooks/useConfirmBfsDoi';

/**
 * Landing page for the confirmation link in the BfS Double-Opt-In email
 * (EBS-64). Reads the token from the URL, confirms the marketing consent on
 * mount, and shows the result. Without a token the link is treated as invalid.
 */
const BfsDoiConfirmationPage = () => {
  const t = useTranslations('pages.bfsDoi');
  const token = useQueryParams(BFS_DOI_TOKEN_QUERY_KEY) as string | null;

  const { mutate, isSuccess, isError } = useConfirmBfsDoi();

  useEffect(() => {
    if (token) {
      mutate({ token });
    }
    // Fire once on mount with the token carried by the email link.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const status: BfsDoiResultStatus = (() => {
    if (!token || isError) {
      return 'error';
    }
    if (isSuccess) {
      return 'success';
    }
    return 'loading';
  })();

  const isSuccessful = status === 'success';

  return (
    <BfsDoiResultPage
      status={status}
      heading={isSuccessful ? t('success.heading') : t('error.heading')}
      subheading={isSuccessful ? t('success.subheading') : t('error.subheading')}
    />
  );
};

export default BfsDoiConfirmationPage;
